import { useNavigate } from "react-router-dom";

const StockMasterHeader = () => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-between items-center px-4 mb-4 bg-white shadow rounded-lg h-[70px]">
      <h2 className="text-xl font-semibold text-gray-800">Stock Master</h2>
      <div className="flex gap-2">
        <button
          onClick={() => navigate("/StockMaster/Categories")}
          className="border border-primary text-primary px-4 py-2 rounded-lg hover:bg-blue-50 transition-colors"
        >
          Manage Categories
        </button>
        <button
          onClick={() => navigate("/StockMaster/New")}
          className="bg-primary text-white px-4 py-2 rounded-lg hover:opacity-90 transition-opacity"
        >
          + New Item
        </button>
      </div>
    </div>
  );
};

export default StockMasterHeader;
